import React from "react";
import {
  FormError,
  FormLabel,
  RadioGroup,
  RadioCard,
  TextInput,
} from "@components";
import { FormGroup, SwitchInput, SwitchLabel, SwitchTag, AccessPermissionsRadioTable } from "../components";
import { useMerchant } from "@auth";
import { aiModule } from "@auth/modules";


const RoleForm = ({ 
  handleSubmit, 
  onSubmit, 
  setValue, 
  control, 
  errors, 
  selectedPaymentRequestLevel,
  selectedAccessPermissions
}) => {

  const { hasModule } = useMerchant();
  const aiEnabled = hasModule(aiModule);

  const roleScope = [
    {
      val: "user", 
      name: "User",
      desc: "The user can only access payment requests sent by them"
    }, 
    {
      val: "branch", 
      name: "Branch",
      desc: "The user can access payment requests sent by all users in the same branch"
    }, 
    {
      val: "merchant", 
      name: "Merchant",
      desc: "The user can access all payment requests"
    }
  ]

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-full max-w-4xl pt-8 pb-20 gap-y-10 flex flex-col">
      <div>
        <h3 className="font-semibold text-lg/6 pb-6">Role details</h3>
        <FormGroup className="pb-6 max-w-md">
          <FormLabel>Role name</FormLabel>
          <TextInput
            displayName="Role name"
            control={control}
            required={true}
            name="name"
            placeholder="Enter a name for the role"
            errors={errors.name}
          />
          <FormError name="name" errors={errors} />
        </FormGroup>
        <FormGroup>
          <FormLabel>Role scope</FormLabel>
          <RadioGroup>
            {roleScope.map((scope) => (
              <RadioCard
                key={scope.val}
                title={scope.name}
                checked={selectedPaymentRequestLevel === scope.val}
                onClick={() => setValue("paymentRequestLevel", scope.val)}
                description={scope.desc}
              />
            ))}
            <FormError name="paymentRequestLevel" errors={errors} />
          </RadioGroup>
          <FormError name="reference" errors={errors} />
        </FormGroup>
      </div>
      <div className="">
        <h3 className="font-semibold text-lg/6 pb-6">System permissions</h3>
        <ul className="space-y-6">
          <li>
            <FormGroup>
              <SwitchInput
                name="isAdmin"
                control={control}
              >
                <SwitchLabel>Manage users and roles</SwitchLabel>
                <SwitchTag>User can add and update users and roles</SwitchTag>
              </SwitchInput>
            </FormGroup>
          </li>
          <li>
            <FormGroup>
              <SwitchInput
                name="canUpdateSettings"
                control={control}
              >
                <SwitchLabel>Manage platform settings</SwitchLabel>
                <SwitchTag>User can update account settings including payments settings and notifications</SwitchTag>
              </SwitchInput>
            </FormGroup>
          </li>
          {aiEnabled && (
            <li>
              <FormGroup>
                <SwitchInput
                  name="useAiFeatures"
                  control={control}
                >
                  <SwitchLabel>AI features</SwitchLabel>
                  <SwitchTag>User can access AI features including risk analysis, the smart chat and Ontik read</SwitchTag>
                </SwitchInput>
              </FormGroup>
            </li>
          )}
        </ul>
      </div>
      <div className="pt-2">
        <h3 className="font-semibold text-lg/6">Access permissions</h3>
        <AccessPermissionsRadioTable radioClicked={(permId, option) => setValue(permId, option)} selectedAccessPermissions={selectedAccessPermissions} />
      </div>
    </form>
  );
}
export default RoleForm;
